import { render, staticRenderFns } from "./ProductDropdown.vue?vue&type=template&id=2d76fd38&scoped=true&"
import script from "./ProductDropdown.vue?vue&type=script&lang=ts&"
export * from "./ProductDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDropdown.vue?vue&type=style&index=0&id=2d76fd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76fd38",
  null
  
)

export default component.exports